import moment from "moment";
import {Modal} from "bootstrap";
import {toast} from "react-toastify";
import {v4 as uuidv4} from "uuid";
import {ReactSession} from "./utils/ReactSession.jsx";
import {AES, enc} from "crypto-js";
import {DateTime} from "luxon";
import ApiRequester from "./components/ApiRequester.jsx";
import {forEach} from "react-bootstrap/ElementChildren";


// Math & String Formatting

export function pt2(num){
    return num.toString().padStart(2, "0");
}

export function padNumber(item, padNum){
    return item.toString().padStart(padNum, "0");
}

function divMod(incoming, dividedBy) {
    if (incoming <= 0) {
        return {total: 0, remainder: 0};
    }else{
        return {total: Math.floor(incoming / dividedBy), remainder: incoming % dividedBy};
    }
}

export function percentageDifference(curVal, newVal) {
  // Calculate the difference between the two numbers.
  let difference = curVal - newVal;
  // Calculate the percentage of the difference.
  let percentage = Math.round(difference / curVal * 100);
  // Return the percentage as string formatted.
  return `${percentage < 0 ? "Down" : "Up"} ${Math.abs(percentage)}%`;
}

export function formatPhone(inStr){
    if (inStr.length > 9){
        return `${inStr.slice(0,3)}-${inStr.slice(3,6)}-${inStr.slice(6,10)}`;
    }
    return inStr;
}

// Date Time Based Utility Functions

export function getTTL(days){
    return Math.round(new Date().getTime() / 1000) + (86400 * days);
}

export function getTimeZone(){
    let dt = new Date();
    if (dt.getTimezoneOffset() >= 0){
        return dt.getTimezoneOffset()/60;
    }
    else{
        return dt.getTimezoneOffset()/-60;
    }
}

export function timezoneAsStringFormat(tzoffset){
    let sign = Math.sign(tzoffset);
    let hours = Math.abs(tzoffset);
    let hoursInt = Math.floor(tzoffset);
    let minutesDecimal = hours - hoursInt;
    let minutes = Math.round(minutesDecimal * 60);
    let formattedMinutes = minutes.toString().padStart(2, "0");
    return `${sign === -1 ? '-' : ''}${hoursInt.toString().padStart(2, '0')}:${formattedMinutes}`;
}

export function getTimestamp(){
    // Creates local datetime formatted %YYYY-%MM-%dd %hh:%mm:%ss
    let dt = new Date(Date.now());
    return `${dt.getFullYear()}-${pt2(dt.getMonth()+1)}-${pt2(dt.getDate())} ${pt2(dt.getHours())}:${pt2(dt.getMinutes())}:${pt2(dt.getSeconds())}`;
}

export function getUTCTimestamp(){
    // Creates UTC datetime formatted %YYYY-%MM-%dd %hh:%mm:%ss
    let ret;
    let dt = new Date(Date.now());
    ret = `${dt.getUTCFullYear()}-${pt2(dt.getUTCMonth()+1)}-${pt2(dt.getUTCDate())} ${pt2(dt.getUTCHours())}:${pt2(dt.getUTCMinutes())}:${pt2(dt.getUTCSeconds())}`;
    return ret;
}

export function formatTimestamp(inDateStr){
    // Creates datetime formated from date string formatted in local format %MM/%dd/%YYYY %hh:%mm:%ss
    let dt = new Date(inDateStr);
    return `${pt2(dt.getMonth()+1)}/${pt2(dt.getDate())}/${dt.getUTCFullYear()} ${pt2(dt.getUTCHours())}:${pt2(dt.getUTCMinutes())}:${pt2(dt.getUTCSeconds())}`;
}

export function formatTimestampIso(inDateStr){
    // Creates datetime formated from date string formatted in iso format %YYYY-%MM-%dd %hh:%mm:%ss
    let dt = new Date(inDateStr);
    return `${dt.getUTCFullYear()}-${pt2(dt.getUTCMonth()+1)}-${pt2(dt.getUTCDate())} ${pt2(dt.getUTCHours())}:${pt2(dt.getUTCMinutes())}:${pt2(dt.getUTCSeconds())}`;
}

export function getQuarterRange(offset=0){
    let ret = ["", ""];
    let dt = new Date(Date.now());
    let quarter = Math.floor(dt.getMonth() / 3 + 1 + offset);
    if (quarter === 1){
        ret[0] = new Date(dt.getFullYear(), 0, 1);
        ret[1] = new Date(dt.getFullYear(), 3, 0);
    }else if (quarter === 2){
        ret[0] = new Date(dt.getFullYear(), 3, 1);
        ret[1] = new Date(dt.getFullYear(), 5, 30);
    }else if (quarter === 3){
        ret[0] = new Date(dt.getFullYear(), 6, 1);
        ret[1] = new Date(dt.getFullYear(), 8, 30);
    }else if (quarter === 4){
        ret[0] = new Date(dt.getFullYear(), 9, 1);
        ret[1] = new Date(dt.getFullYear(), 11, 31);
    }else if (quarter === 0){
        ret[0] = new Date(dt.getFullYear()-1, 9, 1);
        ret[1] = new Date(dt.getFullYear()-1, 11, 31);
    }
    return ret;
}

export function getWeekRange(offset=0){
    let dt = new Date(Date.now());
    let day = dt.getDay();
    let diff = dt.getDate() - day + (day === 0 ? -6 : 1)+(7*offset);
    let first = new Date(dt.setDate(diff));
    let diff2 = first.getDate() + 6;
    let last = new Date(dt.setDate(diff2));
    return [first, last];
}

export function getMonthRange(offset=0){
    let dt = new Date(Date.now());
    let last = new Date(dt.getFullYear(), dt.getMonth()+1+offset, 0);
    return [new Date(dt.getFullYear(), dt.getMonth()+offset, 1), last];
}

export function getYear(offset=0){
    let first = new Date(new Date(Date.now()).getFullYear()+offset, 0, 1);
    let last = new Date(first.getFullYear(), 11, 31);
    return [first, last];
}

export function getToday(offset=0){
    return new Date(new Date().setDate(new Date().getDate() + offset));
}

export function addDaysToDate(dateObj, days){
    // Takes a Date object and a number of days, returns a new Date object with days added
    // days can be positive (future) or negative (past)
    if (!(dateObj instanceof Date)){
        return new Date();
    }
    const result = new Date(dateObj);
    result.setDate(result.getDate() + days);
    return result;
}

export function getY2Date(){
    return [new Date(new Date().getFullYear(), 0, 1), new Date(Date.now())];
}

export function formatDateIso(dateObj){
    // Incoming date object, outputs YYYY-MM-DD formatted string
    return `${dateObj.getFullYear().toString()}-${pt2(dateObj.getMonth()+1)}-${pt2(dateObj.getDate())}`;
}

export function formatDate(dateObj){
    // Incoming date object, outputs MM/DD/YYYY formatted string
    return `${pt2(dateObj.getMonth() + 1)}/${pt2(dateObj.getDate())}/${dateObj.getFullYear()}`;
}

export function formatDateTimeIso(dateObj){
    // Incoming date object, outputs YYYY-MM-DD HH:MM:SS formatted string
    return `${dateObj.getFullYear().toString()}-${pt2(dateObj.getMonth()+1)}-${pt2(dateObj.getDate())} ${pt2(dateObj.getHours())}:${pt2(dateObj.getMinutes())}:${pt2(dateObj.getSeconds())}`;
}

export function formatDateTime12Hour(dateObj){
    // Incoming date object, outputs MM/DD/YYYY haa formatted string (e.g., "12/25/2023 3:00 PM")
    const hours = dateObj.getHours();
    const minutes = dateObj.getMinutes();
    const period = hours >= 12 ? 'PM' : 'AM';
    const displayHours = hours === 0 ? 12 : (hours > 12 ? hours - 12 : hours);
    return `${pt2(dateObj.getMonth() + 1)}/${pt2(dateObj.getDate())}/${dateObj.getFullYear()} ${displayHours}:${pt2(minutes)} ${period}`;
}

export function formatDateNoYear(dateObj){
    // Incoming date object, outputs MM/DD formatted string
    return `${pt2(dateObj.getMonth() + 1)}/${pt2(dateObj.getDate())}`;
}

export function getCurrentYear(){
    let dt = new Date(Date.now());
    return dt.getFullYear();
}

export function durationToNow(eventStart){
    let seconds, h, m, s, modRet, duration, eventdatetime, nowTime;
    h = 0;
    m = 0;
    s = 0;
    eventdatetime = moment.utc(eventStart).unix();
    nowTime = moment().unix();
    seconds = (nowTime - eventdatetime);
    modRet = divMod(seconds, 60);
    m = modRet.total;
    s = modRet.remainder;
    modRet = divMod(m, 60);
    h = modRet.total;
    m = modRet.remainder;
    if (h > 0){
        duration = h+":"+m.toString().padStart(2, "0")+" (hours)";
    }
    else if(m > 0){
        duration = m+":"+s.toString().padStart(2, "0")+" (min)";
    }
    else if (s > 0){
        duration = s+" Seconds";
    }
    else{
        duration = "";
    }
    return duration;
}

export function luxonParseSQLDate(inDate){
    let ret = "";
    if (inDate){
        ret = DateTime.fromSQL(inDate);
    }
    return ret;
}

export function luxonCompareDateTimes(compareTime, compare="lt"){
    if (compare === "lt"){
        return compareTime < DateTime.now();
    }else{
        return compareTime > DateTime.now();
    }
}

export function unpackLabels(inObj) {
    return DateTime.utc().toMillis() / 1000;
}

export function getCurrentEpochTimeInSeconds() {
  return DateTime.utc().toMillis() / 1000;
}

export function getLocalTimeFromEpochMillis(epoch, offset=0){
    return DateTime.fromMillis(epoch ? epoch/1000000 : 0, { zoneOffset: offset ? offset : 0 }).toFormat("D h:mm a");
}

export function getDurationFromFutureEpoch(futureEpoch, offset=0) {
    return parseInt((futureEpoch+offset) - (DateTime.utc().toMillis() / 1000));
}

export function secToTime(insec, offset=0){
    return DateTime.fromSeconds(insec).setZone('utc').toFormat("h:mm a");
}

export function secToTimeUTC(insec, offset=0){
    return DateTime.fromSeconds(insec).setZone('utc').plus(offset*3600000).toFormat("h:mm a");
}

export function convertIsoToLocal(inIsoDatetime){
  let ret = "";
  if (inIsoDatetime){
      try{
          ret = DateTime.fromSQL(inIsoDatetime).toFormat("MM/dd/yyyy h:mma");
      }catch (e){
          ret = "";
      }
  }
  return ret;
}

export function convertIsoUTCToLocalized(inIsoDatetime){
  let ret = "";
  if (inIsoDatetime){
      try{
          ret = moment.utc(inIsoDatetime).local().format("M/D/YYYY h:mm A")
      }catch (e){
          ret = "";
      }
  }
  return ret;
}

export function convertIsoToLocalTime(inIsoDatetime){
  let ret = "";
  if (inIsoDatetime){
      try{
          ret = DateTime.fromSQL(inIsoDatetime).toFormat("h:mma");
      }catch (e){
          ret = "";
      }
  }
  return ret;
}

export function convertIsoToLocalDate(inIsoDatetime){
  let ret = "";
  if (inIsoDatetime){
      try{
          ret = DateTime.fromSQL(inIsoDatetime).toFormat("MM/dd/yyyy");
      }catch (e){
          ret = "";
      }
  }
  return ret;
}


export function convertIsoUTCToLocal(inIsoDatetime, offset){
    let ret = "", tmpDt;
    if (inIsoDatetime){
        try{
            tmpDt = DateTime.fromSQL(inIsoDatetime);
            if (offset <= 0){
                ret = tmpDt.plus({hours: offset}).toFormat("MM/dd/yyyy h:mma");
            }else if (offset >= 0){
                ret = tmpDt.minus({hours: offset}).toFormat("MM/dd/yyyy h:mma");
            }
        }catch (e){
            ret = "";
        }
    }
    return ret;
}

export function convertIsoUTCToLocalIsoDate(inIsoDatetime, offset){
    let ret = "", tmpDt;
    if (inIsoDatetime){
        try{
            tmpDt = DateTime.fromSQL(inIsoDatetime);
            if (offset <= 0){
                ret = tmpDt.plus({hours: offset}).toFormat("yyyy-MM-dd");
            }else if (offset >= 0){
                ret = tmpDt.minus({hours: offset}).toFormat("yyyy-MM-dd");
            }
        }catch (e){
            ret = "";
        }
    }
    return ret;
}

export function convertIsoUTCToLocalDate(inIsoDatetime, offset){
    let ret = "", tmpDt;
    if (inIsoDatetime){
        try{
            tmpDt = DateTime.fromSQL(inIsoDatetime);
            if (offset <= 0){
                ret = tmpDt.plus({hours: offset}).toFormat("MM/dd/yyyy");
            }else if (offset >= 0){
                ret = tmpDt.minus({hours: offset}).toFormat("MM/dd/yyyy");
            }
        }catch (e){
            ret = "";
        }
    }
    return ret;
}

export function getLocalTimeWithOffset(offset){
    let ret, utcTime;
    try{
        if (offset !== undefined){
            utcTime = DateTime.utc().plus({hours: offset});
            ret = utcTime.toFormat("yyyy-MM-dd HH:mm:ss");
        }else{
            ret = DateTime.now().toFormat("yyyy-MM-dd HH:mm:ss");
        }
    }catch (e) {
        ret = "";
    }
    return ret;
}

export function getLuxonUTCTime(){
    return DateTime.utc().toFormat("yyyy-MM-dd HH:mm:ss");
}

export function secondToMinuteSec(insec){
    let minute, minuteText, second, secondText;
    minute = Math.floor(insec / 60);
    second = insec % 60;
    minuteText = minute > 0 ? `${minute} Minute${minute !== 1 ? 's' : ''} ` : "";
    secondText = second > 0 ? `${second} Second${second !== 1 ? 's' : ''} ` : "";
    return `${minuteText}${secondText}`;
}

export function secondToHourMinSec(insec){
    let hour, hourText, minute, minuteText, second, secondText;
    if (insec < 0){
        return "N/A"
    }
    hour = Math.floor(insec / 3600);
    minute = Math.floor((insec % 3600) / 60);
    second = insec - (hour*3600) - (minute * 60);
    hourText = hour > 0 ? `${hour} Hour${hour !== 1 ? 's' : ''} ` : "";
    minuteText = minute > 0 ? `${minute} Minute${minute !== 1 ? 's' : ''} ` : "";
    secondText = second > 0 ? `${second} Second${second !== 1 ? 's' : ''} ` : "";
    return `${hourText}${minuteText}${secondText}`;
}

// Misc Functions

export function getAccessSettings(role, migrated=false){
    let ret
    if (["palcare-admin", "palcare", "corporate", "corporate-admin", 1, 2, 3, 4].includes(role)){
        ret = {Dashboards: {Main: {Read: true, Write: true},
                    Corporate: {Read: true, Write: true}},
              Alerts: {All: {Read: true, Write: true},
                         Emergency: {Read: true, Write: true},
                         Maintenance: {Read: true, Write: true},
                         System: {Read: true, Write: true}},
              Reports: {Alerts: {Read: true, Write: true},
                  Residents: {Read: true, Write: true},
                  Caregiver: {Read: true, Write: true},
                  Inspection: {Read: true, Write: true}},
              Users: {UserManagement: {Read: true, Write: true},
                  Groups: {Read: true, Write: true}},
              Settings: {Mobile: {Read: true, Write: true}},
              Profile: {Read: true, Write: true}}
        if (migrated){
            ret["Community"] = {Residents: {Read: true, Write: true},
                                Buildings: {Read: true, Write: true},
                                Locations: {Read: true, Write: true},
                                Devices: {Read: true, Write: true}}
        }else{
            ret["Community"] = {Residents: {Read: false, Write: false},
                                Buildings: {Read: false, Write: false},
                                Locations: {Read: false, Write: false},
                                Devices: {Read: false, Write: false}}
        }
    }
    else if (["super-admin", "admin", 5, 7].includes(role)){
        ret = {Dashboards: {Main: {Read: true, Write: true},
                            Corporate: {Read: false, Write: false}},
              Alerts: {All: {Read: true, Write: true},
                         Emergency: {Read: true, Write: true},
                         Maintenance: {Read: true, Write: true},
                         System: {Read: true, Write: true}},
              Reports: {Alerts: {Read: true, Write: true},
                        Residents: {Read: true, Write: true},
                        Caregiver: {Read: true, Write: true},
                        Inspection: {Read: true, Write: true}},
              Users: {UserManagement: {Read: true, Write: true},
                      Groups: {Read: true, Write: true}},
              Settings: {Mobile: {Read: true, Write: true}},
              Profile: {Read: true, Write: true}}
        if (migrated){
            ret["Community"] = {Residents: {Read: true, Write: true},
                                Buildings: {Read: true, Write: true},
                                Locations: {Read: true, Write: true},
                                Devices: {Read: true, Write: true}}
        }else{
            ret["Community"] = {Residents: {Read: false, Write: false},
                                Buildings: {Read: false, Write: false},
                                Locations: {Read: false, Write: false},
                                Devices: {Read: false, Write: false}}
        }
    }
    else{
        ret = {Dashboards: {Main: {Read: true, Write: true},
                            Corporate: {Read: false, Write: false}},
            Alerts: {All: {Read: true, Write: true},
                    Emergency: {Read: true, Write: true},
                    Maintenance: {Read: true, Write: true},
                    System: {Read: true, Write: true}},
            Reports: {Alerts: {Read: false, Write: false},
                    Residents: {Read: false, Write: false},
                    Caregiver: {Read: false, Write: false},
                    Inspection: {Read: false, Write: false}},
            Users: {UserManagement: {Read: false, Write: false},
                    Groups: {Read: false, Write: false}},
            Community: {Residents: {Read: false, Write: false},
                        Buildings: {Read: false, Write: false},
                        Locations: {Read: false, Write: false},
                        Devices: {Read: false, Write: false}},
            Settings: {Mobile: {Read: false, Write: false}},
            Profile: {Read: true, Write: true}}
    }
    return ret;
}

export function serverid_to_mac(sId){
    return `${sId.slice(0,2)}:${sId.slice(2,4)}:${sId.slice(4,6)}:${sId.slice(6,8)}:${sId.slice(8,10)}:${sId.slice(10,12)}`.toUpperCase();
}

export function mapPlaceHolder(){
    return (
        <p>
            Portal Map.{' '}
            <noscript>You need to enable JavaScript to see this map.</noscript>
        </p>
    );
}

export function mac_to_serverid(mac) {
    return mac.replaceAll(":", "").replaceAll("-", "").toLowerCase();
}

export function iAmHigherAuthority(comparedRoleWeight, myRoleWeight){
    if ([null, undefined].includes(myRoleWeight)){
        return false;
    }
    return parseInt(myRoleWeight) >= 1000 || parseInt(myRoleWeight) > parseInt(comparedRoleWeight);
}

export function roleWeightById(myRoleId, roleData){
    for (let i = 0; i < roleData?.length; i++){
        if (roleData[i]?.user_role_id === myRoleId){
            return roleData[i]?.user_role_weight;
        }
    }
    return 10;
}

export function roleWeightByName(myRoleName, roleData){
    for (let i = 0; i < roleData?.length; i++){
        if (roleData[i]?.user_role_name === myRoleName){
            return roleData[i]?.user_role_weight;
        }
    }
    return 10;
}

export function compareRole(compared, role){
    if ([undefined, null, ""].includes(role)){
        return false;
    }else{
        if (role === "palcare-admin"){
            return true;
        }
        else if (role === "palcare" && ["corporate-admin", "corporate", "super-admin", "admin", "caregiver", ""].includes(compared)){
            return true;
        }
        else if(role === "corporate-admin" && ["corporate", "super-admin", "admin", "caregiver", ""].includes(compared)){
            return true;
        }
        else if(role === "corporate" && ["super-admin", "admin", "caregiver", ""].includes(compared)){
            return true;
        }
        else if (role === "super-admin" && ["admin", "caregiver", ""].includes(compared)){
            return true;
        }
        else if(role === "admin" && ["caregiver", ""].includes(compared)){
            return true;
        }
        else if (role === "caregiver" && [""].includes(compared)){
            return true;
        }else{
            return false;
        }
    }
}

export function handleSuccess(msg, buttonId, loadBtnId, cancelBtnId){
    let add, load;
    document.getElementById(cancelBtnId).click();
    toast.success(msg);
    add = document.getElementById(buttonId);
    load = document.getElementById(loadBtnId);
    load.classList.add("d-none");
    add.classList.remove("d-none");
    add.classList.add("d-inline-block");
    load.classList.remove("d-inline-block");
}

export function formSuccess(msg, buttonId, loadBtnId, cancelBtnId="", formId=""){
    handleSubmitActions(loadBtnId, buttonId);
    if (cancelBtnId !== ""){
        document.getElementById(cancelBtnId)?.click();
    }
    if (formId !== ""){
        formClear(formId, buttonId);
    }
    toast.success(msg);
}

export function formClear(formId, buttonId){
    let formElement;
    formElement = document.getElementById(formId);
    if (formElement){
        formElement?.reset();
    }
    formCheck(formId, buttonId);
}

export function handleSubmitActions(submitBtn, loadBtn){
    let load, add;
    add = document.getElementById(submitBtn);
    load = document.getElementById(loadBtn);
    add?.classList?.add("d-none");
    load?.classList?.add("d-inline-block");
    load?.classList?.remove("d-none");
}

export function formFail(msg, buttonId, loadBtnId, cancelBtnId=""){
    handleSubmitActions(loadBtnId, buttonId);
    if (cancelBtnId !== ""){
        document.getElementById(cancelBtnId)?.click();
    }
    toast.error(msg);
}

export function getRandomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}

export function formCheck(formId, buttonId){
    // Checks form for validation, toggles save button based on validation being met.
    let form, form2, form3, formArray, formArray2, formArray3, newArray, btn;
    form = document.getElementById(formId).querySelectorAll("input");
    form2 = document.getElementById(formId).querySelectorAll("textarea");
    form3 = document.getElementById(formId).querySelectorAll("select");
    btn = document.getElementById(buttonId);
    formArray = Array.from(form);
    formArray2 = Array.from(form2);
    formArray3 = Array.from(form3);
    newArray = formArray.concat(formArray2).concat(formArray3);
    if (newArray.every((formItem) => {return formItem.checkValidity()})){
        if (btn){
            btn.disabled = false;
            btn.classList.remove("btn-danger");
            btn.classList.add("btn-primary");
        }
    }
    else{
        if (btn){
            btn.disabled = true;
            btn.classList.remove("btn-primary");
            btn.classList.add("btn-danger");
        }
    }
}

export function formCheckV2(formId, buttonId, goodClass, badClass, disable=true){
    // Checks form for validation, toggles save button based on validation being met.
    let form, form2, form3, formArray, formArray2, formArray3, newArray, btn;
    form = document.getElementById(formId).querySelectorAll("input");
    form2 = document.getElementById(formId).querySelectorAll("textarea");
    form3 = document.getElementById(formId).querySelectorAll("select");
    btn = document.getElementById(buttonId);
    formArray = Array.from(form);
    formArray2 = Array.from(form2);
    formArray3 = Array.from(form3);
    newArray = formArray.concat(formArray2).concat(formArray3);
    if (newArray.every((formItem) => {return formItem.checkValidity()})){
        if (btn){
            if (disable){
                btn.disabled = false;
            }
            btn.classList.remove(badClass);
            btn.classList.add(goodClass);
        }
    }
    else{
        if (btn){
            if (disable){
                btn.disabled = true;
            }
            btn.classList.remove(goodClass);
            btn.classList.add(badClass);
        }
    }
}

export function formCheckWithElement(formId, buttonId, e=null, attributeData=[]){
    // Checks form for validation, toggles save button based on validation being met.
    let form, formArray, btn, inputArray, selectArray, formSelect;
    form = document.getElementById(formId).querySelectorAll("input");
    formSelect = document.getElementById(formId).querySelectorAll("select");
    btn = document.getElementById(buttonId);
    inputArray = Array.from(form);
    selectArray = Array.from(formSelect);
    formArray = [...inputArray, ...selectArray];
    if (formArray.every((formItem) => elementCheck(formItem, e, attributeData))){
        btn.disabled = false;
        btn.classList.remove("btn-danger");
        btn.classList.add("btn-primary");
    }
    else{
        btn.disabled = true;
        btn.classList.remove("btn-primary");
        btn.classList.add("btn-danger");
    }
}

function elementCheck(formItem, e, attributeData=[]) {
    if (formItem.id === "serialNum") {
        let exists = false;
        let active = false;
        if (formItem.value.length > 0 && !isNaN(formItem.value)) {
            for (let i = 0; i < attributeData.length; i++) {
                if (formItem.value.toString() === attributeData[i]?.manufacture_uuid.toString()) {
                    exists = true;
                    if (attributeData[i]?.is_active) {
                        active = true;
                    }
                }
            }
            if (exists && active) {
                if (!['shift', 'control', 'tab'].includes(e?.key?.toString()?.toLowerCase())) {
                    toast.warn(`Device ${formItem.value.toString()} is already assigned.`);
                }
            }
        }
    } else if (formItem.id === "password2") {
        if (document.getElementById("password").value !== formItem.value) {
            return false;
        }
    }
    return formItem.checkValidity();
}

export function closeModal(cancelModalBtn){
    document.getElementById(cancelModalBtn).click();
}

export function actionAppearance(start, end, itemList, checkboxId="uCheck"){
    let status, nxtCheck;
    status = false;
    for (let i=start; i <= end; i++){
        nxtCheck = document.getElementById(checkboxId+i.toString());
        if (nxtCheck?.checked){
            status = true;
            break;
        }
    }
    if (status) {
        for (let i2=0; i2 < itemList.length; i2++){
            document.getElementById(itemList[i2])?.classList?.remove("hide");
        }
    }else{
        for (let i2=0; i2 < itemList.length; i2++){
            document.getElementById(itemList[i2])?.classList?.add("hide");
        }
    }
}

export function toggleAllCheckboxes(byNames, checkbox){
    let toggle, checkBoxes;
    toggle = document.getElementById(checkbox);
    checkBoxes = document.getElementsByName(byNames);
    for (let i = 0; i < checkBoxes?.length; i++){
        checkBoxes[i].checked = toggle.checked;
    }
}

export function getZipRegexByCountry(country){
    let zipData = {
        US: "\\d{5}([ \\-]\\d{4})?",
        CA: "[ABCEGHJKLMNPRSTVXY]\\d[ABCEGHJ-NPRSTV-Z][ ]?\\d[ABCEGHJ-NPRSTV-Z]\\d",
        PR: "00[679]\\d{2}([ \\-]\\d{4})?"
    };
    let ret = zipData[country]
    if (!ret){
        ret = "";
    }
    return ret
}

export function getStatesByCountry(country){
    let ret;
    let stateData = {
        "US": [["AL", "Alabama"], ["AK", "Alaska"], ["AZ", "Arizona"], ["AR", "Arkansas"],
               ["CA", "California"], ["CO", "Colorado"], ["CT", "Connecticut"], ["DE", "Delaware"], ["FL", "Florida"],
               ["GA", "Georgia"], ["HI", "Hawaii"], ["ID", "Idaho"], ["IL", "Illinois"], ["IN", "Indiana"],
               ["IA", "Iowa"], ["KS", "Kansas"], ["KY", "Kentucky"], ["LA", "Louisiana"], ["ME", "Maine"],
               ["MD", "Maryland"], ["MA", "Massachusetts"], ["MI", "Michigan"], ["MN", "Minnesota"],
               ["MS", "Mississippi"], ["MO", "Missouri"], ["MT", "Montana"], ["NE", "Nebraska"], ["NV", "Nevada"],
               ["NH", "New Hampshire"], ["NJ", "New Jersey"], ["NM", "New Mexico"], ["NY", "New York"],
               ["NC", "North Carolina"], ["ND", "North Dakota"], ["OH", "Ohio"], ["OK", "Oklahoma"], ["OR", "Oregon"],
               ["PA", "Pennsylvania"], ["RI", "Rhode Island"], ["SC", "South Carolina"], ["SD", "South Dakota"],
               ["TN", "Tennessee"], ["TX", "Texas"], ["UT", "Utah"], ["VT", "Vermont"], ["VA", "Virginia"],
               ["WA", "Washington"], ["WV", "West Virginia"], ["WI", "Wisconsin"], ["WY", "Wyoming"]],
        "CA": [["AB", "Alberta"], ["BC", "British Columbia"], ["NB", "New Brunswick"],
               ["NL", "Newfoundland and Labrador"], ["NS", "Nova Scotia"], ["MB", "Manitoba"], ["ON", "Ontario"],
               ["PE", "Prince Edward Island"], ["QC", "Quebec"], ["SK", "Saskatchewan"]],
        "PR": []
    };
    ret = stateData[country];
    if (!ret){
        ret = [];
    }
    return stateData[country];
}

export function getStateOptionsByCountry(country){
    let ret
    let stateData = {
        "US": [
            <option key={"state-option-al"} value={"AL"}>Alabama</option>,
            <option key={"state-option-ak"} value={"AK"}>Alaska</option>,
            <option key={"state-option-az"} value={"AZ"}>Arizona</option>,
            <option key={"state-option-ar"} value={"AR"}>Arkansas</option>,
            <option key={"state-option-ca"} value={"CA"}>California</option>,
            <option key={"state-option-co"} value={"CO"}>Colorado</option>,
            <option key={"state-option-ct"} value={"CT"}>Connecticut</option>,
            <option key={"state-option-de"} value={"DE"}>Delaware</option>,
            <option key={"state-option-fl"} value={"FL"}>Florida</option>,
            <option key={"state-option-ga"} value={"GA"}>Georgia</option>,
            <option key={"state-option-hi"} value={"HI"}>Hawaii</option>,
            <option key={"state-option-id"} value={"ID"}>Idaho</option>,
            <option key={"state-option-il"} value={"IL"}>Illinois</option>,
            <option key={"state-option-in"} value={"IN"}>Indiana</option>,
            <option key={"state-option-ia"} value={"IA"}>Iowa</option>,
            <option key={"state-option-ks"} value={"KS"}>Kansas</option>,
            <option key={"state-option-ky"} value={"KY"}>Kentucky</option>,
            <option key={"state-option-la"} value={"LA"}>Louisiana</option>,
            <option key={"state-option-me"} value={"ME"}>Maine</option>,
            <option key={"state-option-md"} value={"MD"}>Maryland</option>,
            <option key={"state-option-ma"} value={"MA"}>Massachusetts</option>,
            <option key={"state-option-mi"} value={"MI"}>Michigan</option>,
            <option key={"state-option-mn"} value={"MN"}>Minnesota</option>,
            <option key={"state-option-ms"} value={"MS"}>Mississippi</option>,
            <option key={"state-option-mo"} value={"MO"}>Missouri</option>,
            <option key={"state-option-mt"} value={"MT"}>Montana</option>,
            <option key={"state-option-ne"} value={"NE"}>Nebraska</option>,
            <option key={"state-option-nv"} value={"NV"}>Nevada</option>,
            <option key={"state-option-nh"} value={"NH"}>New Hampshire</option>,
            <option key={"state-option-nj"} value={"NJ"}>New Jersey</option>,
            <option key={"state-option-nm"} value={"NM"}>New Mexico</option>,
            <option key={"state-option-ny"} value={"NY"}>New York</option>,
            <option key={"state-option-nc"} value={"NC"}>North Carolina</option>,
            <option key={"state-option-nd"} value={"ND"}>North Dakota</option>,
            <option key={"state-option-oh"} value={"OH"}>Ohio</option>,
            <option key={"state-option-ok"} value={"OK"}>Oklahoma</option>,
            <option key={"state-option-or"} value={"OR"}>Oregon</option>,
            <option key={"state-option-pa"} value={"PA"}>Oregon</option>,
            <option key={"state-option-ri"} value={"RI"}>Oregon</option>,
            <option key={"state-option-sc"} value={"SC"}>Oregon</option>,
            <option key={"state-option-sd"} value={"SD"}>Oregon</option>,
            <option key={"state-option-tn"} value={"TN"}>Tennessee</option>,
            <option key={"state-option-tx"} value={"TX"}>Texas</option>,
            <option key={"state-option-ut"} value={"UT"}>Utah</option>,
            <option key={"state-option-vt"} value={"VT"}>Vermont</option>,
            <option key={"state-option-va"} value={"VA"}>Virginia</option>,
            <option key={"state-option-wa"} value={"WA"}>Washington</option>,
            <option key={"state-option-wv"} value={"WV"}>West Virginia</option>,
            <option key={"state-option-wi"} value={"WI"}>Wisconsin</option>,
            <option key={"state-option-wy"} value={"WY"}>Wyoming</option>],
        "CA": [
            <option key={"state-option-ab"} value={"AB"}>Alberta</option>,
            <option key={"state-option-bc"} value={"BC"}>British Columbia</option>,
            <option key={"state-option-nb"} value={"NB"}>New Brunswick</option>,
            <option key={"state-option-nl"} value={"NL"}>Newfoundland and Labrador</option>,
            <option key={"state-option-ns"} value={"NS"}>Nova Scotia</option>,
            <option key={"state-option-mb"} value={"MB"}>Manitoba</option>,
            <option key={"state-option-on"} value={"ON"}>Ontario</option>,
            <option key={"state-option-pe"} value={"PE"}>Prince Edward Island</option>,
            <option key={"state-option-qc"} value={"QC"}>Quebec</option>,
            <option key={"state-option-sk"} value={"SK"}>Saskatchewan</option>],
        "PR": []
    };
    ret = stateData[country];
    if (!ret){
        ret = [];
    }
    return ret;
}

export function getCountryOptions(){
    return [
        <option key={"country-option-us"} value={"US"}>United States</option>,
        <option key={"country-option-ca"} value={"CA"}>Canada</option>,
        <option key={"country-option-pr"} value={"PR"}>Puerto Rico</option>
    ]
}

export function getCountryData(){
    return [
        ["US", "United States"],
        ["CA", "Canada"],
        ["PR", "Puerto Rico"]
    ];
}

export function makeLocalUUID(localId, tableName, sId){
    let localPadded = padNumber(localId, 10);
    return `${sId.slice(0, 8)}-${sId.slice(8, 12)}-${getTableId(tableName)}${localPadded.slice(0, 2)}-${localPadded.slice(2, 6)}-${localPadded.slice(6, 10)}${uuidv4().toString().slice(-8,)}`;
}

export function hexToRGB(hexStr){
    let r, g, b;
    hexStr = hexStr.replace("#", "");
    r = parseInt(hexStr.substring(0,2), 16);
    g = parseInt(hexStr.substring(2,4), 16);
    b = parseInt(hexStr.substring(4,6), 16);
    return [r, g, b];
}

export function rgbToHex(rgbArray){
    let r, g, b;
    r = parseInt(rgbArray[0]).toString(16).padStart(2, '0');
    g = parseInt(rgbArray[1]).toString(16).padStart(2, '0');
    b = parseInt(rgbArray[2]).toString(16).padStart(2, '0');
    return `#${r}${g}${b}`
}

function getTableId(table){
    let tbl = table.toLowerCase();
    let tableIdDict = {
        "alarms": "01",
        "campus": "02",
        "corporation": "03",
        "server": "04",
        "service": "05",
        "locations": "06",
        "locationtable": "06",
        "loc": "06",
        "buildings": "08",
        "devices": "09",
        "inovonics": "09",
        "logicaldevices": "10",
        "devicetype": "10",
        "devicetable": "10",
        "dev": "10",
        "residents": "11",
        "groups": "12",
        "group": "12",
        "alarmgrouplist": "13",
        "groupcontactlist": "14",
        "users": "15",
        "user": "15",
        "contacts": "16",
        "contact": "16",
        "matchterms": "17",
        "devicetypes": "18",
        "deviceuses": "19",
        "deviceusage": "19",
        "area": "20",
        "locationareas": "20",
        "deviceschedule": "21",
        "campusconfig": "22",
        "config": "23",
        "sysdata": "25",
        "udpwhitelist": "26",
        "udptable": "26",
        "rerouting": "27",
        "areatable": "20",
        "dnr": "29",
        "scheduletable": "20",
        "escalationtable": "30",
        "escalationprofiles": "30",
        "esc": "30",
        "escalation": "30",
        "matchtermstable": "17",
        "match": "17",
        "carrierdef": "28",
        "carriers": "28",
        "carrier": "28",
        "reportpresettable": "24",
        "reportpreset": "24",
        "schedule": "20",
        "vss": "31",
        "residenttimes": "32",
        "bleusages": "33",
        "report": "34",
        "reportdef": "35",
        "fingerprintrepeater": "37",
        "fingerprintrepeaters": "37",
        "fingerprintdetail": "38",
        "fingerprintdetails": "38",
        "fingerprintsummary": "39",
        "fingerprints": "39"
    };
    return tableIdDict[tbl];
}

export function setACNT(dData, invalue){
    dData.acnt = invalue;
    dData.rounds = dData?.campusData[invalue.toString()]?.is_rounding ? dData?.campusData[invalue.toString()]?.is_rounding : 0;
    dData.checkin = dData?.campusData[invalue.toString()]?.is_resident_checkin ? dData?.campusData[invalue.toString()]?.is_resident_checkin : 0;
    dData.evmSiteId = dData?.campusData[invalue.toString()]?.location_site_id ? dData.campusData[invalue.toString()].location_site_id : "0";
    dData.cloud = dData?.campusData[invalue.toString()]?.is_cloud ? dData?.campusData[invalue.toString()]?.is_cloud : 0;
    dData.hybrid = dData?.campusData[invalue.toString()]?.is_hybrid ? dData?.campusData[invalue.toString()]?.is_hybrid : false;
    dData.legacy = dData?.campusData[invalue.toString()]?.show_legacy ? dData?.campusData[invalue.toString()]?.show_legacy : false;
    dData.new = dData?.campusData[invalue.toString()]?.show_new ? dData?.campusData[invalue.toString()]?.show_new : false;
    dData.server_version = dData?.campusData[invalue.toString()]?.server_version ? dData?.campusData[invalue.toString()]?.show_new : "";
    ReactSession.set("PAL", AES.encrypt(JSON.stringify(dData), import.meta.env.VITE_ESECRET).toString());
}

export function setCheckinACNT(dData, invalue){
    dData.checkin = invalue;
    dData.campusData[dData.acnt.toString()].is_resident_checkin = invalue;
    ReactSession.set("PAL", AES.encrypt(JSON.stringify(dData), import.meta.env.VITE_ESECRET).toString());
}

export function setRoundsACNT(dData, invalue){
    dData.rounds = invalue;
    dData.campusData[dData.acnt.toString()].is_rounding = invalue;
    ReactSession.set("PAL", AES.encrypt(JSON.stringify(dData), import.meta.env.VITE_ESECRET).toString());
}

export function setSoundsMute(dData, invalue){
    dData.soundsOff = invalue;
    ReactSession.set("PAL", AES.encrypt(JSON.stringify(dData), import.meta.env.VITE_ESECRET).toString());
}

export function setReloadTimer(dData, invalue){
    if (dData?.reloadTime){
        dData.reloadTime = invalue;
        ReactSession.set("PAL", AES.encrypt(JSON.stringify(dData), import.meta.env.VITE_ESECRET).toString());
    }
}

export function setDDataCampusExecTime(dData, campusId, invalue){
    dData.campusData[campusId.toString()].exec_excess_time = invalue;
    ReactSession.set("PAL", AES.encrypt(JSON.stringify(dData), import.meta.env.VITE_ESECRET).toString());
}

export function setDDataCampusCustom(dData, keyList, keyValue){
    for (let i=0; i < keyList.length; i++){
        dData.campusData[dData.acnt.toString()][keyList[i]] = keyValue;
    }
    ReactSession.set("PAL", AES.encrypt(JSON.stringify(dData), import.meta.env.VITE_ESECRET).toString());
}

export function campusToGuid(dData, campusId){
    if (dData.campusData[campusId]?.guid){
        return dData.campusData[campusId].guid;
    }else{
        return campusId;
    }
}

export function userToGuid(dData, userId){
    if (dData.cognito){
        return dData.cognito;
    }else{
        return userId;
    }
}

// Table Support Utilities

export function paginateData(records, pageNum, pageLimit){
    // Start = starting index for first item on page
    // End = ending index for first item on page
    // BeginDot = bool to determine starting ellipse or not
    // EndDot = bool to determine ending ellipse or note
    // pageMax = starting page to display in numbered sequence
    // pageMin = ending page to display in numbered sequence
    let recordLength, start, end, beginDot, endDot, pageMin, pageMax, max, diff;
    beginDot = false;
    endDot = false;
    diff = 0;
    recordLength = records?.length ? records.length : 0;
    // calculates the total page numbers and the starting and ending page number in sequence.
    max = Math.ceil(recordLength / pageLimit);
    if (max === 0){
        max = 1;
    }
    if (max > 5){
        pageMin = pageNum - 2;
        if (pageMin < 1){
            diff = 1 - pageMin;
        }
        pageMax = pageNum + (2 + diff)
        if (pageMax > max){
            diff = pageMax - max;
            pageMin = pageMin - diff;
        }
    }
    else{
        pageMin = 1;
        pageMax = max;
    }
    if (pageMin < 1){
        pageMin = 1;
    }
    if (pageMax > max){
        pageMax = max;
    }
    // Sets if ellipses show below
    if (pageMin > 1){
        beginDot = true;
    }
    if (pageMax < max){
        endDot = true;
    }
    // Sets the slice start and endpoint of the data below
    start = ((pageNum - 1) * pageLimit);
    end = pageNum * pageLimit - 1;
    if (end > recordLength){
        end = recordLength;
    }
    if (start < 0){
        start = 0;
    }
    return {start: start, end: end, pageMax: pageMax, pageMin: pageMin, beginDot: beginDot,
            endDot: endDot, max: max};
}

export function boolSort(a, b, column, order){
    if (order === "asc"){
        if (a[column] && !b[column]){
            return 1;
        }
        else if (!a[column] && b[column]){
            return -1;
        }
        else{
            return 0;
        }
    }else{
        if (b[column] && !a[column]){
            return 1;
        }
        else if (!b[column] && a[column]){
            return -1;
        }
        else{
            return 0;
        }
    }
}

export function sortFunc(a, b, column, order){
    let cA, cB, procColumn;
    if (typeof column === "object"){
        procColumn = column[0];
    }else{
        procColumn = column;
    }
    cA = a[procColumn];
    cB = b[procColumn];
    if (cA === null || cA === " "){
        cA = "";
    }
    if (cB === null || cB === " "){
        cB = "";
    }
    if (typeof cA === "string" && typeof cB === "string"){
        if (order === "asc"){
            return cA.localeCompare(cB, "en", {numeric: true});
        }else{
            return cB.localeCompare(cA, "en", {numeric: true});
        }
    }else{
        if(order === "desc") {
            if (cA < cB) {
                return 1;
            } else if (cA > cB) {
                return -1;
            } else {
                return 0;
            }
        } else{
            if (cA > cB) {
                return 1;
            } else if (cA < cB) {
                return -1;
            } else {
                return 0;
            }
        }
    }
}

export function checkAll(start, end, checkboxlist=[], setcheckboxlist=() => {}, headerField="uCheckHead",
                         rowCheckId="uCheck"){
    // Checks and unchecks all boxes from header checkbox
    let status, nxtCheck, entityList = [], newSet, curSet, itemsToRemove;
    console.log({start: start, end: end, checkboxlist: checkboxlist, setcheckboxlist: setcheckboxlist, headerField: headerField, rowCheckId: rowCheckId})
    curSet = new Set(checkboxlist);
    status = document.getElementById(headerField);
    if (status !== null && status.checked){
        for (let i=start; i <= end; i++){
            nxtCheck = document.getElementById(rowCheckId+i.toString());
            if (nxtCheck){
                nxtCheck.checked = true;
                entityList.push(nxtCheck.value.toString());
            }
        }
        newSet = new Set(entityList);
        setcheckboxlist([...newSet.difference(curSet)].concat([...curSet]));
    }else{
        for (let i=start; i <= end; i++){
            nxtCheck = document.getElementById(rowCheckId+i.toString());
            if (nxtCheck) {
                nxtCheck.checked = false;
                entityList.push(nxtCheck.value.toString());
            }
        }
        newSet = new Set(entityList);
        itemsToRemove = curSet.intersection(newSet);
        setcheckboxlist(checkboxlist.filter((item) => !itemsToRemove.has(item)));
    }
}

export function checkUserAll(start, end, dData, checkboxlist=[], setcheckboxlist=() => {}, headerField="uCheckHead", rowCheckId="uCheck"){
    // Checks and unchecks all boxes from header checkbox with user validation setting.
    let status, nxtCheck, nxtRole, entityList = [];
    status = document.getElementById(headerField);
    if (status.checked){
        for (let i=start; i < end; i++){
            nxtCheck = document.getElementById(rowCheckId+i.toString());
            nxtRole = document.getElementById("user_role"+i.toString());
            if (nxtRole === null){
                nxtRole = document.getElementById("UserRole"+i.toString());
            }
            if (nxtCheck){
                if (nxtRole){
                    if (!compareRole(nxtRole.innerText, dData)){
                        nxtCheck.checked = true;
                        entityList.push(nxtCheck.value.toString());
                    }
                }else{
                    nxtCheck.checked = true;
                    entityList.push(nxtCheck.value.toString());
                }
            }
        }
        setcheckboxlist(entityList);
    }else{
        for (let i=start; i < end; i++){
            nxtCheck = document.getElementById(rowCheckId+i.toString());
            if (nxtCheck){
                nxtCheck.checked = false;
            }
        }
        setcheckboxlist([]);
    }
}

export function range(start, end){
    let arr = [];
    for (let i = start; i <= end; i++) {
        arr.push(i);
    }
    return arr;
}

export function columnSorter(column, sorter, setSorter){
    // Sorts current set of data in real time.
    let compareColumn = sorter.sortColumn;
    if (typeof compareColumn === "object"){
        compareColumn = compareColumn[0];
    }
    if (typeof column === "object"){
        column = column[0];
    }
    if (compareColumn !== column){
        setSorter(prevState => {
            return {sortColumn: column, sortOrder: "asc"};
        });
    }
    else{
        if (sorter.sortOrder === "asc"){
            setSorter(prevState => {
                return {...prevState, sortOrder: "desc"};
            });
        }
        else{
            setSorter(prevState => {
                return {...prevState, sortOrder: "asc"};
            });
        }
    }
}

// Modal Utility Functions

export function showModal(modalId){
    let modal;
    modal = new Modal(document.getElementById(modalId), {});
    modal.show();
}

export function hideModal(modalId){
    let modal;
    modal = Modal.getInstance(document.getElementById(modalId), {});
    modal.hide();
}

export function swapModal(curModalCnlBtn, newModal){
    document.getElementById(curModalCnlBtn)?.click();
    showModal(newModal);
}

export function searchFunc(input, searchData, keylist){
    if ([null, undefined, ""].includes(input)){
        return searchData;
    }
    const inputLower = input.toString().toLowerCase();
    return searchData.filter((item) => {
        return keylist.some((key) => {
            if (Array.isArray(key)){
                // Handle array keys - combine multiple fields and check both orders
                if (key.length === 2){
                    const val1 = item?.[key[0]];
                    const val2 = item?.[key[1]];
                    if (val1 && val2){
                        const combined1 = `${val1} ${val2}`.toLowerCase();
                        const combined2 = `${val2} ${val1}`.toLowerCase();
                        return combined1.includes(inputLower) || combined2.includes(inputLower);
                    }
                }
                return false;
            }else{
                if (!item?.[key]){
                    return false;
                }
                return item[key].toString().toLowerCase().includes(inputLower);
            }
        })
    })
}

// Helper function to get original key and filterKey from headerData
function getHeaderDataForFilterKey(filterKey, headerData){
    return headerData.find(h => (h.filterKey || h.key) === filterKey);
}

export function headerFilterFunc(dataOrigin, headerFilters, headerData){
    return dataOrigin.filter(item => {
        return Object.keys(headerFilters).every(filterKey => {
            if (!headerFilters[filterKey] || headerFilters[filterKey].length === 0){
                return true;
            }
            const headerDataItem = getHeaderDataForFilterKey(filterKey, headerData);
            const originalKey = headerDataItem?.key || filterKey;
            const extractKey = headerDataItem?.filterKey; // This is the key to extract from objects in arrays
            let value;
            if (Array.isArray(originalKey)){
                value = item[extractKey];
            }else{
                value = item[originalKey];
            }
            // Handle array values
            if (Array.isArray(value)) {
                // If array is empty, only match if filter includes empty string
                if (value.length === 0) {
                    return headerFilters[filterKey].includes("");
                }
                // For non-empty arrays, exclude empty string from filter matching
                const extractedValues = value.map(arrayItem => {
                    if (arrayItem && typeof arrayItem === 'object' && extractKey) {
                        // Extract the filterKey value from the object
                        return arrayItem[extractKey];
                    }
                    // If it's a primitive or no extractKey, use the value directly
                    return arrayItem;
                }).filter(v => v !== null && v !== undefined).map(v => String(v));
                // Filter out empty string from filter values when checking non-empty arrays
                const nonEmptyFilters = headerFilters[filterKey].filter(fv => fv !== "");
                // If only empty string was in filter, non-empty arrays don't match
                if (nonEmptyFilters.length === 0) {
                    return false;
                }
                // Check if any extracted value matches any non-empty filter value
                return nonEmptyFilters.some(filterValue =>
                    extractedValues.some(extractedValue =>
                        extractedValue === filterValue || extractedValue.includes(filterValue)
                    )
                );
            } else {
                // Handle non-array values (including comma-delimited strings)
                const stringValue = String([null, undefined].includes(value) ? "" : value);
                return headerFilters[filterKey].some(filterValue => Array.isArray(stringValue) ? stringValue.includes(filterValue) : stringValue === filterValue);
            }
        });
    });
}

export function deleteModalSingle(display, username, cancelBtn="cancelEditBtn", intext="Are you sure you wish to delete"){
    let modal, modalContent, oldModal;
    oldModal = document.getElementById(cancelBtn);
    modal = new Modal(document.getElementById("deletemodal"), {});
    modalContent = document.getElementById("deleteModalContent");
    modalContent.innerText = `${intext} ${display}?`;
    document.getElementById("uContent").value = username;
    oldModal.click();
    modal.show();
}

export function bulkDeleteModal(start, end, tableData, displayItem, recIdItem, nameItem, setDContent, intext="Are you sure you wish to delete the following records? \n", modalNameId="bulkdeletemodal", modalContentId="deleteBulkModalContent", uId="uCheck"){
    let modal, display, recIdList, modalContent, nameList, tmpRecs, contentHeader;
    display = "";
    recIdList = [];
    nameList = [];
    for (let i=start; i < end; i++){
        let nxtCheck = document.getElementById(uId+i.toString());
        if (nxtCheck?.checked){
            if (typeof displayItem === "object"){
                for (let i2=0; i2 < displayItem.length; i2++){
                    if (i2+1 === displayItem.length){
                        display += `${tableData[i][displayItem[i2]]}\n`
                    }else{
                        display += `${tableData[i][displayItem[i2]]} `
                    }
                }
            }else{
                display += `${tableData[i][displayItem]}\n`;
            }
            tmpRecs = [];
            for (let i3 = 0; i3 < recIdItem.length; i3++){
                tmpRecs.push(tableData[i][recIdItem[i3]]);
            }
            recIdList.push(tmpRecs);
            nameList.push(tableData[i][nameItem]);
        }
    }
    setDContent(recIdList);
    contentHeader = document.getElementById(modalContentId+"Header");
    contentHeader.innerText = intext;
    modalContent = document.getElementById(modalContentId);
    modalContent.innerText = `${display}`;
    document.getElementById("uContent").value = nameList;
    modal = new Modal(document.getElementById(modalNameId), {});
    modal.show();
}


export function callActionModal(start, end, tableData, displayItem, recIdItem, nameItem, setDContent,
                                modalId, contentId, customText, checkboxId="uCheck"){
    let modal, display, recIdList, modalContent, nameList, tmpRecs;
    display = "";
    recIdList = [];
    nameList = [];
    for (let i=start; i < end; i++){
        let nxtCheck = document.getElementById(`${checkboxId}${i}`);
        if (nxtCheck?.checked){
            if (typeof displayItem === "object"){
                display += tableData[i][displayItem[0]] + " " + tableData[i][displayItem[1]] + ", ";
            }else{
                display += tableData[i][displayItem] + ", ";
            }
            tmpRecs = [];
            for (let i2 = 0; i2 < recIdItem.length; i2++){
                tmpRecs.push(tableData[i][recIdItem[i2]]);
            }
            recIdList.push(tmpRecs);
            nameList.push(tableData[i][nameItem]);
        }
    }
    setDContent(recIdList);
    display = display.slice(0, -2);
    modalContent = document.getElementById(contentId);
    modalContent.innerText = `${customText} \n\n${display}`;
    document.getElementById("uContent").value = nameList;
    modal = new Modal(document.getElementById(modalId), {});
    modal.show();
}


export function strTimeDifference(time1, time2){
    let dt1 = DateTime.fromSQL(time1);
    let dt2 = DateTime.fromSQL(time2);
    let seconds = dt2.diff(dt1, "seconds").seconds;
    return secondToHourMinSec(seconds);
}


export function standardSort(a, b, ascending=true){
    let cA, cB;
    if (typeof a === "string"){
        if (!isNaN(a)){
            cA = parseInt(a);
        }else{
            cA = a;
        }
    }else{
        cA = a;
    }
    if (typeof b === "string"){
        if (!isNaN(b)){
            cB = parseInt(b);
        }else{
            cB = b;
        }
    }else{
        cB = b;
    }
    if(ascending) {
        if (cA < cB) {
            return 1;
        } else if (cA > cB) {
            return -1;
        } else {
            return 0;
        }
    }
    else{
        if (cA > cB) {
            return 1;
        } else if (cA < cB) {
            return -1;
        } else {
            return 0;
        }
    }
}

export function isTimeTodayPassed(sendTime, offset=0){
    let utcnow, nowdt, midnight, secFromMidnight, secondsFromTime;
    secondsFromTime = convertHHMMtoSec(sendTime);
    utcnow = DateTime.now().toUTC();
    nowdt = utcnow.plus({hours:offset});
    midnight = nowdt.startOf("day");
    secFromMidnight = nowdt.diff(midnight, "seconds").seconds;
    return secFromMidnight > secondsFromTime;
}

export function calculateSendTime(frequencyId, freqRate, sendTime, offset){
    let days, utcDatetime, parsedTime, sendHour, sendMinute, localDatetime, freqRateList = [];
    utcDatetime = DateTime.now().toUTC();
    localDatetime = utcDatetime.plus({hours: offset});
    parsedTime = sendTime.split(":");
    sendHour = parsedTime[0];
    sendMinute = parsedTime[1];
    for (let i=0; i < freqRate?.length; i++){
        freqRateList.push(parseInt(freqRate[i]));
    }

    if (frequencyId === 1){
        days =  freqRateList.length > 0 ? freqRateList[0] : 1;
        if (!isTimeTodayPassed(sendTime, offset)){
            days = 0;
        }
    }else if (frequencyId === 2){
        let curWeekday = localDatetime.weekday;
        freqRateList.sort((a,b) => standardSort(a, b, false))
        for (let i=0; i < freqRateList.length; i++){
            if (freqRateList[i] > curWeekday){
                days = freqRateList[i] - curWeekday;
            }
            if (days){
                break;
            }
        }
        if (!days){
            if (!isTimeTodayPassed(sendTime, offset)){
                days = 0;
            }else{
                days = 6 - curWeekday + freqRateList[0];
            }
        }
    }else{
        let curDay = localDatetime.day;
        // Sort list to ensure numerical order, this is important
        freqRateList.sort((a,b) => standardSort(a, b, false));
        // If zero in array, need to move to the end as represents end of month, very important.
        if (freqRateList.includes(0)){
            freqRateList = freqRateList.filter((value) => {return value !== 0});
            freqRateList.push(0);
        }
        // Iterate to verify if next scheduled day is later this month.
        for (let i=0; i < freqRateList.length; i++){
            if (freqRateList[i] > curDay){
                // Found a day this month, set days to timedelta.
                days = freqRateList[i] - curDay;
            }else if(freqRateList[i] === 0){
                // handling end of month symbolic integer
                if (curDay === localDatetime.endOf("month").day && !isTimeTodayPassed(sendTime, offset)){
                    days = 0;
                }else{
                    days = localDatetime.endOf("month").day - curDay;
                }
            }
            if (days || days === 0){
                // Break if days set to ensure we get the next upcomming one, not the last one.
                break;
            }
        }
        // If days is undefined that means no days later this month are set so we are looking at a day
        // earlier in the month for next month or possibly today but later today.
        if (!days && days !== 0){
            // Check to see if we need to schedule a report for later today if month day and time not passed is true.
            if (freqRateList.includes(curDay.toString()) && !isTimeTodayPassed(sendTime, offset)){
                days = 0;
            }else{
                days = localDatetime.endOf("month").day - curDay + freqRateList[0];
            }
        }
    }
    let nextDatetime = localDatetime.plus({days: days});
    nextDatetime = nextDatetime.set({hour: parseInt(sendHour), minute: parseInt(sendMinute), second: 0});
    nextDatetime = nextDatetime.minus({hours: offset});
    return nextDatetime.toFormat("yyyy-MM-dd HH:mm:ss");
}

export function toggleCollapse(button, content){
    document.getElementById(content).classList.toggle("show");
    if (document.getElementById(content).classList.contains("show")){
        document.getElementById(button).classList.toggle("fe-plus");
        document.getElementById(button).classList.toggle("fe-minus");
    }else{
        document.getElementById(button).classList.toggle("fe-plus");
        document.getElementById(button).classList.toggle("fe-minus");
    }
}

export function convertHHMMtoSec(intime){
    let seconds = 0;
    let timeArray = intime.split(":");
    seconds += parseInt(timeArray[0]) * 3600;
    seconds += parseInt(timeArray[1]) * 60;
    return seconds;
}

export function convertSectoHHMM(intime){
    let timestamp, hours, minutes;
    if (intime !== 86400){
        hours = pt2(Math.floor(intime / 3600));
        minutes = pt2(Math.round((intime % 3600) / 60));
        timestamp = `${hours}:${minutes}`;
    }else{
        timestamp = "23:59"
    }
    return timestamp;
}

export function convertSecto12Hour(intime){
    let timestamp, hours, minutes, period;
    if (intime === 86400){
        return "11:59 PM";
    }
    
    hours = Math.floor(intime / 3600);
    minutes = Math.floor((intime % 3600) / 60);
    
    if (hours === 0){
        hours = 12;
        period = "AM";
    } else if (hours < 12){
        period = "AM";
    } else if (hours === 12){
        period = "PM";
    } else {
        hours = hours - 12;
        period = "PM";
    }
    
    timestamp = `${hours}:${pt2(minutes)} ${period}`;
    return timestamp;
}

export function hourToLocalizedHour(hour){
    if (typeof hour !== 'number' || hour < 0 || hour > 23) {
        return "00:00";
    }else{
        const now = DateTime.local().set({ hour: hour, minute: 0, second: 0, millisecond: 0 });
        return now.toFormat('hh:mm a');
    }
}

export function hourTo12HourFormat(hour){
    // Takes an hour (0-24) and returns it in 12-hour format
    // Hours 0 and 24 return "12:00 AM"
    if (typeof hour !== 'number' || hour < 0 || hour > 24) {
        return "12:00 AM";
    }
    
    let displayHour = hour;
    let period = "AM";
    
    // Handle 0 and 24 as 12 AM
    if (hour === 0 || hour === 24) {
        displayHour = 12;
        period = "AM";
    } else if (hour === 12) {
        displayHour = 12;
        period = "PM";
    } else if (hour > 12) {
        displayHour = hour - 12;
        period = "PM";
    } else {
        displayHour = hour;
        period = "AM";
    }
    
    return `${displayHour}:00 ${period}`;
}

export function timeOfDayUTCtoLocalized(secIn, tz){
    let offset, newTime;
    offset = tz * 3600;
    newTime = secIn + offset;
    if (newTime < 0){
      return 86400 + newTime;
    }else if (newTime > 86399){
      return newTime - 86400;
    }else{
      return newTime;
    }
}

export function highlightText(isExtreme, isWeighted, isOver, weightValue){
    // Builds hover text for weighted icons. Examples include '$Value $threshold: $weighted $overunder $value $end'
    return `${isExtreme} | ${isWeighted ? "Weighted" : "Value"} ${isOver ? "over" : "under"} ${weightValue}${isWeighted ? "% of total" : ""}`;
}

export function timeOfDayLocalizedtoUTC(secIn, tz){
    return timeOfDayUTCtoLocalized(secIn, tz * -1);
}

export function isThreshold(weightValue, compareValue, weight=50.0, weighted, overunder=">"){
    // This function is to return false if the cell value is less than 50% above the compare average.
    let ret = false;
    if (typeof compareValue === "string"){
        if (isNaN(compareValue)){
            return false;
        }
    }
    if (weighted){
        if (typeof weightValue === "string"){
            if (isNaN(weightValue)){
                return false;
            }
        }
        if ([">", "over", "gt"].includes(overunder.toLowerCase())){
            if ((parseFloat(weightValue) / parseFloat(compareValue) * 100) > weight){
                ret = true;
            }
        }else{
            if ((parseFloat(weightValue) / parseFloat(compareValue) * 100) < weight){
                ret = true;
            }
        }
    }else{
        if ([">", "over", "gt"].includes(overunder.toLowerCase())){
            if (parseFloat(compareValue) > weight){
                ret = true;
            }
        }else{
            if (parseFloat(compareValue) < weight){
                ret = true;
            }
        }
    }
    return ret;
}

export function setRoleInfo(weight, dData){
    dData.role_weight = weight;
    ReactSession.set("PAL", AES.encrypt(JSON.stringify(dData), import.meta.env.VITE_ESECRET).toString());
}

export function reloadSessionCorp(corpId, index, cognitoId, dData, campusIdOverride=0){
    if (parseInt(index) >= 0){
        document.getElementById(`edit-modal${index}`)?.classList?.add("d-none");
        document.getElementById(`edit-modal-spinner${index}`)?.classList?.remove("d-none");
    }
    ApiRequester({reqEndpoint: "sessionLoad", pKey: "corporate_id", pVal: corpId, myId: cognitoId,
                        campus_override: campusIdOverride}).then(data => {
        if (parseInt(index) >= 0 || parseInt(index) === -99){
            if (parseInt(index) >= 0){
                document.getElementById(`edit-modal${index}`)?.classList?.remove("d-none");
                document.getElementById(`edit-modal-spinner${index}`)?.classList?.add("d-none");
            }
            if (data[0]){
                clearFilters(dData);
                toast.success("Session switched to new corp");
                sleepThenExecute(1000, () => {
                    return window.location.href = "/";
                });
            }else{
                toast.fail("Session switch failed, contact support if failure persists");
            }
        }else{
            if (data[0]){
                console.log("Session updated");
            }else{
                console.log("Session update failed");
            }
        }
    });
}


export function reloadSessionCampusItems(campusId, dataK, dataV, reload=false){
    let bData, dData;
    bData = AES.decrypt(ReactSession.get("PAL"), import.meta.env.VITE_ESECRET);
    dData = JSON.parse(bData.toString(enc.Utf8));
    for (let i=0; i < dataK.length; i++){
        dData.campusData[campusId][dataK[i]] = dataV[i];
    }
    ReactSession.set("PAL", AES.encrypt(JSON.stringify(dData), import.meta.env.VITE_ESECRET).toString());
    if (reload){
        window.location.reload();
    }
}


export function clearFilters(dData, write=true){
    let bData;
    if (write === true){
        bData = AES.decrypt(ReactSession.get("PAL"), import.meta.env.VITE_ESECRET);
        dData = JSON.parse(bData.toString(enc.Utf8));
    }
    dData.areaFilter = [];
    dData.areaGroupFilter = [];
    dData.areaTypeFilter = [];
    dData.devFilter = [];
    dData.devCatFilter = [];
    dData.resFilter = [];
    dData.residentGroupFilter = [];
    dData.typeFilter = [];
    dData.userFilter = [];
    dData.responseFilter = [false, "lt", 60];
    dData.userGroupFilter = [];
    dData.reasonFilter = [];
    dData.areaFilterLabel = [];
    dData.areaGroupFilterLabel = [];
    dData.areaTypeFilterLabel = [];
    dData.devFilterLabel = [];
    dData.devCatFilterLabel = [];
    dData.resFilterLabel = [];
    dData.residentGroupFilterLabel = [];
    dData.typeFilterLabel = [];
    dData.userFilterLabel = [];
    dData.userGroupFilterLabel = [];
    dData.reasonFilterLabel = [];
    dData.responseFilterLabel = ["Response time", "less than", "60 minutes"];
    if (write === true){
        ReactSession.set("PAL", AES.encrypt(JSON.stringify(dData), import.meta.env.VITE_ESECRET).toString());
    }
    return dData;
}


export function setResFilters(dData, resId, resName){
    dData = clearFilters(dData, false);
    dData.resFilter = [resId];
    dData.resFilterLabel = [resName];
    ReactSession.set("PAL", AES.encrypt(JSON.stringify(dData), import.meta.env.VITE_ESECRET).toString());
}

export function setAreaFilters(dData, areaId, areaName){
    dData = clearFilters(dData, false);
    dData.areaFilter = [areaId];
    dData.areaFilterLabel = [areaName];
    ReactSession.set("PAL", AES.encrypt(JSON.stringify(dData), import.meta.env.VITE_ESECRET).toString());
}

export function setDeviceFilters(dData, devId, devName){
    dData = clearFilters(dData, false);
    dData.devFilter = [devId];
    dData.devFilterLabel = [devName];
    ReactSession.set("PAL", AES.encrypt(JSON.stringify(dData), import.meta.env.VITE_ESECRET).toString());
}

export function setUserFilters(dData, userId, username){
    dData = clearFilters(dData, false);
    dData.userFilter = [userId];
    dData.userFilterLabel = [username];
    ReactSession.set("PAL", AES.encrypt(JSON.stringify(dData), import.meta.env.VITE_ESECRET).toString());
}

export function sleepThenExecute(ms, process) {
  return new Promise(() => setTimeout(process, ms));
}

export function reloadSessionCampus(campusId, index, cognitoId){
    ApiRequester({reqEndpoint: "sessionLoad", pKey: "campus_id", pVal: campusId, myId: cognitoId}).then(data => {
        if (data[0]){
            console.log("Session updated");
        }else{
            console.log("Session update failed");
        }
    });
}

export function getIsoStandard(offset=0, showMillis=false, showTZ=false){
    let nowdt, newdt;
    nowdt = DateTime.now();
    newdt = nowdt.plus({days: offset}).set({millisecond: 0});
    return newdt.toISO({includeOffset: showTZ, suppressMilliseconds: !showMillis});
}

export function getBorderColor(alertType){
    if (["maint", "maintenance", "system"].includes(alertType.toLowerCase())){
        return "#9fc6ff";
    }else{
        return "#dc3545";
    }
}

export function complexDelimDisplay(originText, newText){
    // Function used to build filter display inside the schedule modal pop up.
    // This function is generic takes lists recursively and builds appending comma delim strings.
    let ret;
    if (originText){
        if (newText){
            ret = `${originText}, ${newText}`;
        }else{
            ret = originText;
        }
    }else {
        ret = newText;
    }
    return ret;
}

export function HHMMtoLocalTime(inTime){
    let dt = DateTime.fromISO(inTime);
    return dt.toFormat("h:mm a");
}

export function isEmergency(eventCatId){
    return [1,7,10,11,12,14,15].includes(eventCatId);
}

// Helper function to normalize values for comparison
function normalizeValue(value) {
    // Treat undefined, null, empty string, and 0 as equivalent
    if (value === undefined || value === null || value === "" || value === 0) {
        return null;
    }
    return value;
}

export function arrayComparison(arr1, arr2){
    if (arr1.length !== arr2.length) {
        return true;
    }

    // Iterate through the arrays and compare each element
    for (let i = 0; i < arr1.length; i++) {
        const normalized1 = normalizeValue(arr1[i]);
        const normalized2 = normalizeValue(arr2[i]);

        // console.log(`${normalized1} | ${typeof normalized1}`)
        // console.log(`${normalized2} | ${typeof normalized2}`)
        if (normalized1 !== normalized2) {
            return true; // A difference was found, so the arrays are different
        }
    }

    // If the loop completes without finding any differences, the arrays are the same
    return false;
}

export function areaLearninBehaviorToggle(value){
    if (["7", "23"].includes(value.toString())){
        // Doorbell and Doorbell w/reset, only needs alarm behavior
        document.getElementById("behavior-heading-container")?.classList?.remove("d-none");
    }
    else if (["8", "9", "20", "21"].includes(value.toString())){
        // Door and window based devices, includes with resets.
        document.getElementById("behavior-heading-container")?.classList?.remove("d-none");
    } else {
        document.getElementById("behavior-heading-container")?.classList?.add("d-none");
    }
}


export function determineDevName(devName, devTypeId){
    if (["2", "19"].includes(devTypeId)){
        return "Waterproof Pendant";
    }else{
        return devName;
    }
}

export function responseErrorHandler(response){
    if (response?.status === 503){
        return {"Status": "Error", "ErrorCode": 11, "Res": {}};
    }else if (response?.status === 500){
        return {"Status": "Error", "ErrorCode": 10, "Res": {}};
    }else if (response?.status === 403){
        return {"Status": "Error", "ErrorCode": 12, "Res": {}};
    }else{
        return response.json();
    }
}

export function isBannerPresent(){
    let check = document.getElementsByClassName("header-spacerX")
    return check.length > 0;
}

export function arraysEqual(arr1, arr2) {
    let a1 = [...arr1], a2 = [...arr2];
    if (a1.length !== a2.length) {
        return false;
    }
    // a1.sort();
    // a2.sort();
    for (let i = 0; i < a1.length; i++) {
        if (a1[i] !== a2[i]) {
            return false;
        }
    }
    return true;
}

export function rangeSliderHandler(v, spanId, inputId){
    let newVal, newPos, span, e;
    span = document.getElementById(spanId);
    e = document.getElementById(inputId);
    newVal = Number((e.value - e.min) * 100 / (e.max - e.min));
    newPos = 10 - (newVal * .175);
    span.style.left = `calc(${newVal}% + (${newPos}px))`;
}

export function confirmModalHandler(args){
    let modal, display, recIdList, modalContent, nameList, tmpRecs, start, end, tableData, displayItem, recIdItem,
        nameItem, setDContent, checkboxId, modalName, contentId, bodyText, uContent, submitId, titleId, titleText,
        submitBtn, submitBtnFunc, title;
    if (args?.rights){
        start = args?.start_index ? args.start_index : 0;
        end = args.end_index ? args.end_index : 0;
        tableData = args?.table_data ? args.table_data : [];
        displayItem = args?.display_item ? args.display_item : "";
        recIdItem = args?.record_item ? args.record_item : ["", ""];
        nameItem = args?.name_item ? args.name_item : "";
        setDContent = args?.content_setter ? args.content_setter : () => {};
        checkboxId = args?.checkbox_id ? args.checkbox_id : "uCheck";
        modalName = args?.modal_name ? args.modal_name : "confirmmodal";
        contentId = args?.content_id ? args.content_id : "confirmModalModalContent";
        bodyText = args?.body_text ? args.body_text : "";
        uContent = args?.stored_content_id ? args.stored_content_id : "uContent";
        submitId = args?.submit_id ? args.submit_id : "confirmModalSubmit";
        submitBtnFunc = args?.submit_func ? args.submit_func : () => {};
        titleId = args?.title_id ? args.title_id : "staticConfirmModalBackdropLabel";
        titleText = args?.title ? args.title : "";
        display = "";
        recIdList = [];
        nameList = [];
        for (let i=start; i < end; i++){
            let nxtCheck = document.getElementById(`${checkboxId}${i}`);
            if (nxtCheck?.checked){
                display += `${tableData[i][displayItem]}, `;
                tmpRecs = [];
                for (let i2 = 0; i2 < recIdItem.length; i2++){
                    tmpRecs.push(tableData[i][recIdItem[i2]]);
                }
                recIdList.push(tmpRecs);
                nameList.push(tableData[i][nameItem]);
            }
        }
        setDContent(recIdList);
        display = display.slice(0, -2);
        title = document.getElementById(titleId);
        title.innerText = titleText;
        submitBtn = document.getElementById(submitId);
        submitBtn.onclick = submitBtnFunc;
        modalContent = document.getElementById(contentId);
        modalContent.innerText = `${bodyText} \n\n${display}`;
        document.getElementById(uContent).value = nameList;
        modal = new Modal(document.getElementById(modalName), {});
        modal.show();
    }else{
        toast.warn("You do not have permissions to perform this action.");
    }
}


export function versionSort(a, b){
    const v1 = a.split('.').slice(0, 3);
    const v2 = b.split('.').slice(0, 3);
    for (let i = 0; i < Math.max(v1.length, v2.length); i++) {
        const part1 = parseInt(v1[i] || '0', 10);
        const part2 = parseInt(v2[i] || '0', 10);

        if (part1 > part2) {
            return 1; // v1 is greater
        } else if (part1 < part2) {
            return -1; // v2 is greater
        }
    }
    return 0; // versions are equal
}

export function buildChartDataset(chartType, dataArray, labelKey, dataKeys, bgColors){
    let ret = [];
    for (let i=0; i < dataArray.length; i++){
        ret.push({
            type: chartType,
            label: dataArray[i][labelKey],
            data: unpackFieldsToArray(dataArray[i], dataKeys),
            backgroundColor: bgColors[i],
            hoverBackgroundColor: bgColors[i]+"78",
            borderColor: bgColors[i]+"78",
            borderWidth: 3,
            pointRadius: 5,
            pointHoverRadius: 7,
            pointBorderWidth: 1,
            tension: 0.4,
            fill: false,
            yAxisID: "a",
            order: i+1
        })
    }
    return ret;
}

export function unpackFieldsToArray(dataItem, keyArray){
    let ret = [];
    for (let i=0; i < keyArray.length; i++){
        ret.push(dataItem[keyArray[i]]);
    }
    return ret;
}

export function formatDateToMMDD(dateString){
    // Converts YYYY-MM-DD format to MM/DD format
    if (!dateString) return "";
    
    try {
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return "";
        
        const month = pt2(date.getMonth() + 1);
        const day = pt2(date.getDate());
        return `${month}/${day}`;
    } catch (e) {
        return "";
    }
}